

// * redux type defined hook

import { useDispatch, useSelector } from "react-redux";
import store from "../store";

export type StoreState = ReturnType<typeof store.getState>
export type StoreDispatch = typeof store.dispatch;

// * 类型定义Hook - useSelector的类型定义
export const useTypedSelector = useSelector.withTypes<StoreState>();
// * 类型定义Hook - useDispatch的类型定义
export const useTypedDispatch = useDispatch.withTypes<StoreDispatch>();


